export default __webpack_public_path__ + "static/media/header.7c149df8.jpg";